// src/mixins/alerts.js
export default {
  methods: {
    /**
     * Muestra un mensaje de error
     * @param {string} mensaje - Mensaje a mostrar
     */
    mostrarError(mensaje) {
      this.$bvToast.toast(mensaje, {
        title: "Error",
        variant: "danger",
        solid: true,
        autoHideDelay: 5000
      });
    },

    /**
     * Muestra un mensaje de éxito
     * @param {string} mensaje - Mensaje a mostrar
     */
    mostrarExito(mensaje) {
      this.$bvToast.toast(mensaje, {
        title: "Éxito",
        variant: "success",
        solid: true,
        autoHideDelay: 3000
      });
    },

    /**
     * Muestra un mensaje de advertencia
     * @param {string} mensaje - Mensaje a mostrar
     */
    mostrarAdvertencia(mensaje) {
      this.$bvToast.toast(mensaje, {
        title: "Advertencia",
        variant: "warning",
        solid: true,
        autoHideDelay: 4000
      });
    }
  }
}